import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as Sentry from '@sentry/react'
import dayjs from 'dayjs';
import 'dayjs/locale/id'
import {initializeSignOzTracing} from '@echoteam/signoz-react'

dayjs.locale('id');
initializeSignOzTracing({
  serviceName: window.REACT_APP_SIGNOZ_SERVICE_NAME,
  serviceVersion: window.REACT_APP_SIGNOZ_SERVICE_VERSION,
  environment: window.REACT_APP_SIGNOZ_ENV,
  serviceNamespace: window.REACT_APP_SIGNOZ_SERVICE_NAMESPACE,
  url: window.REACT_APP_SIGNOZ_URL,
  traceSampleRate: window.REACT_APP_SIGNOZ_TRACE_SAMPLE_RATE,
  allowedOrigins: [
    'https://api.compabuy.codr-staging.id',
    'https://otlphttp.signoz.echoteam.tech',
    /^https:\/\/.*\.echoteam\.tech$/
  ]
});

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
